var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"ui-nav-item",class:{ 'is-active': _vm.active },attrs:{"href":_vm.href},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"ui-nav-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }